// frontend/src/content/regression-de.js
// All German copy for the Regression website.
// Import this file into components — never hardcode strings.

export const meta = {
  title: "Seelenrückführung & Regression Sessions — Benjamin Kurtz",
  description:
    "Past Life Regression Sessions mit Benjamin Kurtz. Hypnose, Seelenarbeit und Energiearbeit — online oder vor Ort.",
};

// ═══════════════════════════════════════════════════════════
// HEADER
// ═══════════════════════════════════════════════════════════
export const header = {
  nav: [
    { label: "Regression", anchor: "#was-ist" },
    { label: "Für wen?", anchor: "#fuer-wen" },
    { label: "Science", anchor: "#science" },
    { label: "Über Benjamin", anchor: "#ueber" },
    { label: "Ablauf", anchor: "#prozess" },
    { label: "Erfahrungen", anchor: "#cases" },
  ],
  cta: "Freier Intro Call",
};

// ═══════════════════════════════════════════════════════════
// HeroV3Section — HERO
// ═══════════════════════════════════════════════════════════
export const hero = {
  label: "BENJAMIN KURTZ ACADEMY",
  headlineLine1: "Deine Seele",
  headlineLine2: "erinnert sich.",
  heroCta: "Bist du bereit zuzuhören?",
  subline: "Seelenrückführung · Hypnose · Energiearbeit — online und im Präsenz bei dir.",
  ctaPrimary: "Freien Intro Call buchen",
  ctaSecondary: "Podcast-Gespräch anhören →",
  videoPlaceholder: "[ Intro-Video Benjamin Kurtz ]",
  videoUrl: "https://media.thelightcall.com/video/riverside_benjamin_raw-video-cfr_benjamin_kurtz's%20st_0015_trim.mp4",
  posterUrl: "https://media.thelightcall.com/video-thumbnails/welcome_regresson_video_thumbnail.jpg",
  vimeoEmbedUrl: "https://player.vimeo.com/video/1168643769",
};

// ═══════════════════════════════════════════════════════════
// ServicesSection — SERVICES
// ═══════════════════════════════════════════════════════════
export const services = {
  items: [
    { label: "Erinnere alte Seelenleben", sub: "Seelen-Rückführung" },
    { label: "Neuprogrammierung & Ausrichtung", sub: "Hypnotherapie" },
    { label: "Master Reiki & Quantenenergiearbeit", sub: "Energiearbeit" },
  ],
  location: "online & vor Ort",
};

// ═══════════════════════════════════════════════════════════
// WelcomeSection — WELCOME
// ═══════════════════════════════════════════════════════════
export const welcome = {
  headline: "Hi, ich bin Benjamin.\nSchön, dass du hier bist.",
  quoteLines: [
    "Hier erfährst du, was Regressions und Past Life Regression Sessions sind, wie sie dir helfen können, und was wirklich in einer Session passiert.",
    "Außerdem findest du hier Podcast-Episoden, wissenschaftliche Hintergründe und die Möglichkeit, in einem freien Intro Call direkt mit mir in Kontakt zu treten.",
    "Ich freu mich von dir zu hören.",
    "Viel Freude.",
  ],
  author: "Benjamin",
  imageUrl: "https://media.thelightcall.com/images/2%20s%20350px.png",
  signatureUrl: "https://media.thelightcall.com/images/signature_benjamin_black.png",
};

// ═══════════════════════════════════════════════════════════
// StatementSection — STATEMENT
// ═══════════════════════════════════════════════════════════
export const statement = {
  variant: 'light',
  lines: [
    "Es gibt Erfahrungen, die unser Verstand alleine nicht greifen kann.",
    "Erinnerungen, die nicht nur aus diesem Leben stammen.",
    "Muster, die jenseits dieses Lebens entspringen.",
  ],
};

// ═══════════════════════════════════════════════════════════
// QuoteSection — Featured quote on primary blue
// ═══════════════════════════════════════════════════════════
export const quoteSection = {
  variant: 'dark',
  id: 'quote',
  // Brian Weiss always first. Add more quotes here — component rotates automatically.
  quotes: [
    {
      lines: [
        "Das wahre Du, das unsterbliche Du,",
        "ist jenes, das von Körper zu Körper,",
        "von Leben zu Leben weiterbesteht.",
      ],
      author: "Brian L. Weiss MD",
    },
    {
      lines: [
        "Es gibt mehr im Himmel und auf Erden,",
        "als man sich in der Phantasie",
        "erträumen kann.",
      ],
      author: "Roger Woolger Ph.D.",
    },
    {
      lines: [
        "Mir scheint, wir haben eine ausreichende",
        "Anzahl an Fällen, die stark",
        "auf eine Wiedergeburt hindeuten.",
      ],
      author: "Ian Stevenson MD",
    },
    {
      lines: [
        "So schwer es zu glauben sein mag –",
        "es gibt Hinweise darauf, dass ein Leben",
        "nach dem Tod tatsächlich Realität sein könnte.",
      ],
      author: "Jim B. Tucker MD",
    },
  ],
};

// ═══════════════════════════════════════════════════════════
// WhatIsSection — WHAT IS REGRESSION
// ═══════════════════════════════════════════════════════════
export const whatIs = {
  label: "REGRESSION SESSIONS",
  headline: "Was bedeutet Regression und was ist eine Seelenrückführung?",
  body: [
    "Regression, lateinisch regressus = Rückschritt/e, bedeutet, zurückzugehen zu früheren Erfahrungen, zu älteren Erinnerungen. Um zu verstehen, warum du heute so reagierst, wie du re-agierst. Warum bestimmte Muster sich immer wiederholen. Warum manche Themen sich anfühlen, als würdest du sie schon länger als dieses Menschenleben kennen.",
    "Eine Seelenrückführung geht weiter. Es kann Fragen beantworten, warum dir manche Menschen so bekannt vorkommen, obwohl du sie erst gerade kennengelernt hast. Warum dir bestimmte Gaben einfach liegen oder Themen brennend interessieren.",
    "Stell dir einen Filmstreifen vor: Jedes einzelne Bild ist ein Leben — von Geburt bis Tod. Wenn du ihn nah heranziehst, bist du mittendrin. Wenn du ihn zurückziehst, siehst du unzählige Bilder hintereinander. Das ist etwa so, wie wir lineare Erlebnisse erinnern. Manche Menschen erleben und erinnern Seelenleben aber parallel. Das heißt, jenseits von dem, was wir mit unserem Verstand greifen können.",
    "In einem tiefen Entspannungszustand, in dem du jederzeit die vollständige Kontrolle behältst — können wir diesen Strom an Bildern und Leben zugänglich machen. Was dir dann begegnet, ist immer genau das, was du in diesem Moment brauchst.",
  ],
};

// ═══════════════════════════════════════════════════════════
// PodcastVideoSection — PODCAST VIDEO
// ═══════════════════════════════════════════════════════════
export const podcasts = [
  {
    id: "berggesundheit-052",
    label: "IM PODCAST, FOLGE #52",
    headline: "Reinkarnation: Was, wenn der Tod nicht das Ende ist?",
    sectionHeadline: "Manche erinnern sich jenseits dieses Lebens.",
    sectionBody: `"Auf einmal haben sich Dinge zusammengesetzt, die vorher unerklärbar waren." Eine Regression Session zeigt dir nicht nur was war — sie zeigt dir, warum du so bist, wie du bist. Benjamin im ausführlichen Gespräch mit Tobias Berg über Reinkarnation, Seelenerinnerung und was wirklich in einer Session passiert.`,
    subline:
      "Benjamin im ausführlichen Podcast-Gespräch über Seelenrückführung, Reinkarnation und was wirklich in einer Session passiert.",
    youtubeEmbedUrl: "https://www.youtube.com/watch?v=U5L07PmViis",
    youtubeTitle: "Reinkarnation: Was, wenn der Tod nicht das Ende ist?",
    thumbnailUrl: "https://img.youtube.com/vi/U5L07PmViis/maxresdefault.jpg",
    ctaBelow: "Freien Intro Call buchen",
    listenLabel: "Podcast-Gespräch anhören",
    episodeLabel: "Episode 52",
    episodeHost: "berggesundheit · Tobias Berg",
    episodeDuration: "1:14:32",
    episodeAudioUrl: "https://audio.podigee-cdn.net/2364431-m-438ee3d6d68b8de82a26986fecfd35e8.mp3",
    podcastLinks: [
      { label: "Spotify", url: "https://open.spotify.com/episode/3D9V2pK9kdT6ED9FENxpnW?si=7rD9pMrcSV6uLq-tOoMICA" },
      { label: "Apple", url: "https://podcasts.apple.com/pt/podcast/episode-52-reinkarnation-was-wenn-der-tod-nicht-das-ende-ist/id1680846180?i=1000751332298" },
      { label: "YouTube", url: "https://youtu.be/U5L07PmViis?si=r1aB93QVAkpFgd97" },
    ],
  },
];

// ═══════════════════════════════════════════════════════════
// ForWhomSection — FOR WHOM
// ═══════════════════════════════════════════════════════════
export const forWhom = {
  label: "FÜR WEN",
  headline: "Wer kommt zu einer Regressions-Session?",
  intro:
    "Manche kommen mit einem konkreten Thema: eine Angst, die sich nicht erklären lässt. Ein Beziehungsmuster, das sich immer wiederholt. Körperliche Beschwerden ohne klare Ursache. Ein Verlust, der nicht heilen will. Andere kommen mit einer größeren Frage: Warum bin ich hier? Was soll ich mit diesem Leben anfangen? Und manche kommen aus reiner Neugier — und finden dabei etwas, womit sie nicht gerechnet haben.",
  columns: 4,
  topics: [
    { title: "Ängste & Panikattacken", body: "Wenn die Reaktion größer ist als die Situation." },
    { title: "Beziehung", body: "Warum sich Dynamiken in Beziehung wiederholen." },
    { title: "Körperliche Symptome", body: "Wenn der Körper trägt, was der Geist nicht verarbeiten konnte." },
    { title: "Todesangst & Endloses Leben", body: "Den Tod als Übergang verstehen, nicht als Ende." },
    { title: "Lebensaufgabe & Purpose", body: "Warum bin ich hier — und was soll ich damit tun?" },
    { title: "Kontakt zu Verstorbenen", body: "Wenn jemand gegangen ist und etwas ungesagt blieb." },
    { title: "Spirituelle Entwicklung", body: "Bewusstsein erweitern jenseits von Konzepten." },
    { title: "Channeling lernen", body: "Die Verbindung zu anderen Quellen öffnen." },
  ],
};

// ═══════════════════════════════════════════════════════════
// AboutSection — ABOUT BENJAMIN
// ═══════════════════════════════════════════════════════════
export const about = {
  label: "ÜBER BENJAMIN KURTZ",
  headline: "Was mich zu dieser Arbeit gerufen hat",
  body: [
    "Mein erster Kontakt mit Seelenrückführung war kein sanftes Erwachen. Ich buchte ein Tagescoaching, weil ich Themen hatte, die auch ich als Coach nicht alleine lösen konnte. In einer der letzten Stunden — nach fast zehn Stunden Arbeit — führten mich die Coaches in ein früheres Seelenleben. Was ich darin erfahren habe, hat mir Dinge erklärt, die ich jahrelang nicht verstehen konnte. Durch direktes Erleben wurde es lebendig und schenkte mir Klarheit.",
    "Ich begleite Menschen seit mehr als einem Jahrzehnt — als NLP-Master, Hypnotherapeut, EMDR- und Wingwave-Practitioner, Reiki- und Quanten-Master Heiler. Mit einem Hintergrund in Unternehmertum als Filmemacher und Fotograf, Master in Design, einer spirituellen Praxis, die mich von Köln über Indien bis hin zum Nomadentum geführt hat, und der tiefen Überzeugung: Regression Sessions sind keine weitere Methode. Sie sind der Raum, in dem sich am tiefsten etwas zeigen kann.",
  ],
  credentials: [
    "NLP Master & NR Practitioner",
    "Hypnose-Coach",
    "EMDR · wingwave® Coach",
    "Reiki Master Teacher (Usui)",
    "Aufstellungsarbeit",
    "Breathwork & Meditation",
    "Past Life Regression",
    "Psilocybin Retreat Facilitator",
  ],
  credentialsLabel: "AUSBILDUNGEN & ZERTIFIZIERUNGEN",
  photoPlaceholder: "[ Foto Benjamin Kurtz ]",
};

// ═══════════════════════════════════════════════════════════
// ProcessSection — PROCESS
// ═══════════════════════════════════════════════════════════
export const processSection = {
  label: "DER PROZESS",
  headline: "Von unserem ersten Gespräch bis zur Integration",
  steps: [
    {
      number: "01",
      title: "Freier Intro Call",
      duration: "Kostenlos · 30 Minuten",
      body: "Ein echtes Erstgespräch. Wir schauen gemeinsam, wonach du suchst, ich helfe dir Lebens-Themen zu sortieren, wie eine Session abläuft, und ob es passt.",
    },
    {
      number: "02",
      title: "Die Session",
      duration: "60–90 Minuten · 1:1 online oder vor Ort",
      body: "Du bleibst die ganze Zeit bei dir. Ich führe dich in einen tiefen Entspannungszustand und navigiere, was dort auftaucht. Du behältst die Kontrolle.",
    },
    {
      number: "03",
      title: "Integration",
      duration: "15–20 Minuten · 5–10 Tage später",
      body: "Was in einer Session entsteht, braucht Zeit zum Setzen. Dieser Anruf gibt dir Raum, das Erlebte zu verankern und offene Fragen zu klären.",
    },
  ],
  footnote:
    "Viele Klienten buchen mehrere Sessions — nicht weil sie müssen, sondern weil sie wollen. Die erste Session lässt so viel mehr Neugierde entstehen, da sich oft Räume öffnen, die bisher verborgen lagen.",
  cta: "Freien Intro Call buchen",
};

// ═══════════════════════════════════════════════════════════
// PodcastSection — PODCAST LINKS
// ═══════════════════════════════════════════════════════════
// Note: Podcast content is in 'podcast' export above (PodcastVideoSection)

// ═══════════════════════════════════════════════════════════
// CaseStudiesSection — CASE STUDIES
// ═══════════════════════════════════════════════════════════
export const cases = {
  label: "FALLBEISPIELE",
  headline: "Geschichten aus der Praxis — wenn Seelen sich erinnern",
  body: "Wenn Menschen ihre Geschichten teilen, zeigt es ihre authentische Stärke. Mit Bewunderung für ihren Mut erzähle ich hier einige ihrer Fälle und ihre positiven Auswirkungen. Alle Geschichten wurden mit ausdrücklichem Einverständnis geteilt. Namen mit * wurden durch Wunsch des Klienten geändert.",
  anonymityNote: "* Name wurde geändert",
  clickHint: "Klicke auf eine der Geschichten, um sie zu lesen.",
  items: [
    {
      name: "Marina", gender: "female",
      image: "https://media.thelightcall.com/client-portraits/Marina-%202.jpeg",
      title: "Ein neuer Bauplan",
      teaser: "Knöcheltief ins Meer — unmöglich. Ein Erlebnis zwischen den Leben löste, was Jahre nicht lösen konnten.",
      tag: "Todesangst · Trauma · Zwischen den Leben",
      situation: "Marina kam mit etwas, das sie nicht benennen konnte: Panik, wenn das Wort Tod fiel. Schweißnasse Hände bei der Frage \"Was wäre, wenn du noch zwei Wochen zu leben hättest?\" Eine starke Angst vor Kontrollverlust. Und knöcheltief ins Meer gehen — unmöglich, obwohl sie das Wasser liebte. Ihr Stiefvater war im Meer an einem Blutgerinnsel gestorben. Scheinbar der Ursprung. Aber etwas war tiefer.",
      session: "Die Trance war so tief, dass Marina nicht mehr sprechen konnte — etwas, das häufig passiert und ganz normal ist. Wir kommunizierten mit vorher vereinbarten Handzeichen. Sie fand sich in Dunkelheit und folgte einem Licht. Was sich zeigte, war kein Trauma: Sie war keine feste Form mehr, sondern eine durchlässige Kugel — ohne Körper. Auf einer großen Bühne mit anderen Wesen wie ihr. Marina empfing den Bauplan, Mensch zu werden — wie eine DNA, die in eine Zelle eintritt. Sie war zwischen den Leben. Sie erlebte womöglich den Ursprung ihrer eigenen Inkarnation.",
      result: "Als ich ihr die Frage danach noch einmal stellte — zwei Wochen zu leben — war sie vollkommen ruhig: \"Dann würde ich den Menschen sagen, dass ich sie liebe.\" Am gleichen Abend ging sie bis zur Hüfte ins Meer. Keine Panik. Ein Jahr später: eine veränderte Wahrnehmung des Lebens, mehr Offenheit, mehr Neugierde. Auch ihr Bauch fühlt sich anders an — nicht mehr schwer wie vorher, sondern warm, angenehm dunkel, wie ein Himmel ohne Sterne. Ein tiefes Urvertrauen, dass nichts wirklich endet — nur die Form, nicht das Leben.",
    },
    {
      name: "Anna", gender: "female",
      image: "https://media.thelightcall.com/client-portraits/Anna-krickel.jpg",
      title: "Zurück nach Hause",
      teaser: "Sie fühlte sich in Konflikten wie eine andere Person. Die Antwort lag dreißig Jahre zurück.",
      tag: "Trauma · Channeling · Familiensystem",
      situation: "Sie kam mit explosiven Reaktionen in zwischenmenschlichen Konflikten — und dem Gefühl, in diesen Momenten nicht sie selbst zu sein. Etwas, das sie häufiger überschattete und sich ganz und gar nicht wie ihr eigener Schatten anfühlte. Im Vorgespräch zeigte sich ein möglicher Zusammenhang: eine Großmutter, die sich vor Annas Geburt das Leben genommen hatte.",
      session: "Im Trancezustand fand sich Anna in einem Raum aus Schatten — nicht auf der Erde, nicht zu Hause. Sie war jemand anders: die Großmutter, gefangen zwischen den Welten, voller Scham, überzeugt einen Fehler gemacht zu haben, ohne Weg zurück ins Licht. Aus dieser Perspektive sah sie die kleine Anna unten auf der Erde, drei Jahre alt. Dann der Wechsel — mit Hilfe eines Zwischenwesens wurde Anna sie selbst. Von dort kam sie in einen vorgeburtlichen Raum, wo ihr ein Wesen ein Ritual zeigte: Hände wie eine Schale, Licht einladen — um sich auch nach der Geburt an den Ursprung, an die Quelle zu erinnern. Dieses Ritual reichte sie an die Großmutter weiter. Zwei Minuten Stille. Augen flimmern. Dann, ganz ruhig: \"Ich habe sie zurückgeführt.\"",
      result: "Möglicherweise war der Schatten über all die Jahre die Großmutter. Die explosiven Reaktionen, das angegriffene Nervensystem in Konflikten — möglicherweise Kontaktversuche aus den Zwischenwelten. In der Session zeigte sich auch ein Bild davon, warum die Großmutter sich damals das Leben genommen hatte — etwas, das der ganzen Familie Frieden gab. Heute spürt Anna eine klare Verbindung zu ihren Engeln. Die Verbindung zur Lichtquelle — einmal etabliert — bleibt.",
    },
    {
      name: "Javi", gender: "male",
      image: "https://media.thelightcall.com/client-portraits/javi.jpg",
      title: "Die Angst, nicht zu genügen",
      teaser: "1730. Ein Dorf. Ein Haus am See. Und die Erklärung für eine Angst, die kein Verstand lösen konnte.",
      tag: "Beziehungsangst · Seelenleben · Musterauflösung",
      situation: "Javi wartete auf eine Frau, die er über Monate kennengelernt hatte — ihr erstes gemeinsames Wochenende stand bevor. Er hatte alles perfekt vorbereitet. Und trotzdem: ein innerer Stress, ein Übertunen, eine Angst darunter, die er kannte, ohne sie zu kennen. Die Angst, nicht zu genügen.",
      session: "Es ging sehr schnell. Javi war 1730, zwischen 28 und 32 Jahre alt. Er arbeitete mit einem Geschäftspartner. Die Frau dieses Partners hatte sich in ihn verliebt — er hatte sie nicht ermutigt, nichts war passiert. Doch der Geschäftspartner wurde eifersüchtig, erfand Geschichten über ihn und ließ ihn aus dem Dorf vertreiben. Dann dunklere Szenen: ein Kessel mit schwarzer Flüssigkeit, Versklavung, Gefängnis — Strafe für etwas, das er nicht getan hatte. Vier oder fünf Jahre später ein anderes Bild: ein Haus am See, eine glückliche Frau und spielende Kinder. Ein Haus, das er sein Heim nannte, in dem er absoluten inneren Frieden fand.",
      result: "Die Angst von heute hatte ihren Ursprung 1730 — die Erfahrung, alles richtig zu machen und trotzdem alles zu verlieren. Aber auch die verlorene Erinnerung, dass es nach dem Verlust ein glückliches Zuhause geben kann. Ein Ankommen, ein Zuhause-sein — tiefer als der gewohnte Verstand reicht. Als Javi das verstand, wandelte sich der innere Druck. Er und seine Partnerin leben heute glücklich und gemeinsam in der Nähe von Valencia, mit Blick aufs Wasser.",
    },
  ],
  sectionLabels: {
    situation: "Ausgangssituation",
    session: "In der Session",
    result: "Ergebnis",
  },
};

// ═══════════════════════════════════════════════════════════
// ResearchersSection — RESEARCHERS & AUTHOR QUOTES
// ═══════════════════════════════════════════════════════════
export const researchers = {
  authorBigLabel: "REGRESSION LEGENDEN",
  authorHeadline: "Wenn Forscher aus Erfahrung sprechen",
  authorLabel: "WAS DIE FORSCHUNG SAGT",
  accordion: {
    readMore: "Mehr lesen",
    readLess: "Weniger lesen",
  },
  // portraitFocus options for author images:
  // - "center"      (default, centered horizontally and vertically)
  // - "top"         (centered horizontally, aligned to top)
  // - "bottom"      (centered horizontally, aligned to bottom)
  // - "left"        (aligned to left, centered vertically)
  // - "right"       (aligned to right, centered vertically)
  // - "top-left"    (aligned to top-left corner)
  // - "top-right"   (aligned to top-right corner)
  // - "bottom-left" (aligned to bottom-left corner)
  // - "bottom-right" (aligned to bottom-right corner)
  //
  // Author data structure:
  // - id:            unique identifier (e.g., "brian-weiss")
  // - featured:      boolean, shows author in Featured Researcher section
  // - name:          display name
  // - role:          job title / affiliation
  // - lifeDates:     birth/death years (e.g., "*1944–2024")
  // - portrait:      R2 image URL
  // - portraitFocus: image focus position (see options above)
  // - quote:         general quote (for potential future use)
  // - featuredQuote: quote displayed in Featured Researcher section
  // - shortVersion:  brief description for accordion preview
  // - longVersion:   full description when expanded
  // - sourceLabel:   link text for source (e.g., "Quelle")
  // - sourceUrl:     URL for source link
  authors: [
// —————————————————————————————————————————————————————————
// Author: Roger Woolger //
// —————————————————————————————————————————————————————————
    {
      id: "roger-woolger",
      name: "Roger Woolger Ph.D.",
      role: "Jungianischer Analytiker, Regressionstherapeut, Autor und Begründer des Deep Memory Process",
      lifeDates: "*1944–2011",
      portrait: "https://media.thelightcall.com/authors/roger_woolger.jpg",
      portraitFocus: "center",
      portraitFocal: { x: 50, y: 50 },
      quote: "Es gibt mehr im Himmel und auf Erden, als man sich in der Phantasie erträumen kann.",
      featuredQuote: "Es gibt mehr im Himmel und auf Erden, als man sich in der Phantasie erträumen kann.",
      shortVersion: "Jungianischer Analytiker, Regressionstherapeut und Autor. Schrieb 'Other Lives, Other Selves' (1987) — in 8 Sprachen übersetzt. Co-Gründer von EARTh und Begründer des Deep Memory Process (DMP).",
      longVersion: `Roger Woolger war ein jungianischer Analytiker und Regressionstherapeut mit herausragendem akademischem Hintergrund: Abschlüsse in Psychologie, Philosophie und Comparative Religion von der Oxford University und dem King's College London, Ausbildung am C.G. Jung Institute in Zürich und Gastprofessor am Vassar College. Er war Co-Gründer von EARTh (European Association for Regression Therapy) und half bei der Etablierung professioneller Standards für das Fachgebiet. Seine besondere Gabe war, innere Prozesse nicht nur psychologisch, sondern spirituell lesbar zu machen: von Traum- und Symbolarbeit bis zu Sufismus, westlicher Mystik und Poesie, verwoben mit Musik, Story, Meditation und Humor.

"Other Lives, Other Selves" (1987) ist eines der einflussreichsten Werke der Regressionstherapie — in 8 Sprachen übersetzt. Das Buch präsentiert eine Synthese aus Jung'scher Tiefenpsychologie, Bodywork, Psychodrama, Yoga-Psychologie, schamanischen Perspektiven und meditativen Prinzipien, inklusive Übergangs- und Zwischenzuständen aus tibetisch-buddhistischen Lehren. Woolger entwickelte das Konzept der "Früherleben-Komplexe" als Erweiterung von Jungs Komplextheorie — die Idee, dass "die psychischen, emotionalen und physischen Eindrücke, die in einem Leben angelegt werden, in irgendeiner Weise auf zukünftige Leben übertragen werden." Dieses Rahmenwerk bot eine theoretische Brücke zwischen analytischer Psychologie und Regressionstherapie.

Aus seiner jahrzehntelangen Praxis entwickelte Woolger den Deep Memory Process (DMP): eine kreative Synthese aus Jung'scher aktiver Imagination, Reichianischer somatischer Körpertherapie, Moreno's Psychodrama, Gestalttherapie und tibetisch-buddhistischer Bardo-Weisheit. DMP ist ein Ansatz für Deep Memory Access, der Regression, Embodiment, Dreamwork, Meditation und Regression Shamanism verbindet. Er veröffentlichte mehrere Artikel im Journal of Regression Therapy, darunter "Imaginal Techniques in Past-Life Therapy" (Vol. I, No. 1, 1986) und "Aspects of Past-Life Bodywork" (Issues 3 und 4). Er bildete Therapeuten international aus und prägte Spiritual Healing Conferences, in denen Themen wie Regression & Schamanismus, Seelenverlust und die sakrale Verbindung von Körper und Geist im Zentrum standen. Seine Position war klar: "So viele Fälle von 'unheilbaren' Depressionen, Phobien, Ängsten und körperlichen Erkrankungen finden vollständige Auflösung, wenn die Ursache jenseits des aktuellen Lebens geheilt wird."`,
      sourceLabel: "Quelle",
      sourceUrl: "https://regressionjournal.org/jrt_author/roger-woolger-1944-2011/",
    },
// —————————————————————————————————————————————————————————
// Author: Ian Stevenson //
// —————————————————————————————————————————————————————————
    {
      id: "ian-stevenson",
      name: "Ian Stevenson M.D.",
      role: "University of Virginia, DOPS Gründer",
      lifeDates: "*1918–2007",
      portrait: "https://media.thelightcall.com/authors/Ian_Stevenson_3_beige.jpg",
      portraitFocus: "center",
      portraitFocal: { x: 50, y: 20 },
      quote: "Mir scheint, wir haben eine ausreichende Anzahl an Fällen, die stark auf eine Wiedergeburt hindeuten.",
      featuredQuote: "Mir scheint, wir haben eine ausreichende Anzahl an Fällen, die stark auf eine Wiedergeburt hindeuten.",
      shortVersion: "Über 2.500 untersuchte Fälle weltweit. Begründer der wissenschaftlichen Reinkarnationsforschung und der Division of Perceptual Studies (1967) an der University of Virginia.",
      longVersion: `Ian Stevenson gilt als Begründer der wissenschaftlichen Reinkarnationsforschung. 1961 begann er mit systematischen Untersuchungen von Kindern, die spontane Erinnerungen an vergangene Leben berichteten. Seine erste Reise nach Indien im Jahr 1961 war wegweisend: In vier Wochen fand er 25 Fälle, und er realisierte, dass diese Phänomene viel häufiger vorkommen als angenommen.

Über vier Jahrzehnte hinweg untersuchte Stevenson über 2.500 Fälle weltweit. Seine Arbeit zeichnet sich durch strenge wissenschaftliche Methodik aus: Jeder Fall wurde vor Ort dokumentiert, Erinnerungen mit historischen Fakten verglichen und alternative Erklärungen systematisch ausgeschlossen. 1966 veröffentlichte er sein wegweisendes Buch "Twenty Cases Suggestive of Reincarnation", das im American Journal of Psychiatry rezensiert wurde mit dem Hinweis: "In Bezug auf Reinkarnation hat er akribisch und unemotionell eine detaillierte Serie von Fällen in Indien gesammelt, bei denen die Beweise schwer auf andere Weise zu erklären sind." Es folgte die vierteilige Reihe "Cases of the Reincarnation Type" (1975-1983) mit Fällen aus Indien, Sri Lanka, Libanon, Türkei, Thailand und Burma — sowie sein Hauptwerk "Reincarnation and Biology" (1997), ein 2.200-seitiges Werk, das über 200 Fälle dokumentiert, in denen Geburtsmale von Kindern Wunden auf Verstorbenen entsprachen.

Die Ergebnisse sind bemerkenswert: Kinder konnten detaillierte Informationen über Familien, Orte und Umstände von Personen berichten, die Jahre vor ihrer Geburt verstorben waren. Viele dieser Details ließen sich später verifizieren. Stevenson entdeckte, dass über 70% der Fälle unnatürliche Todesfälle betrafen, und viele Kinder zeigten Verhaltensweisen und Phobien, die mit dem vorherigen Leben verbunden schienen. Bei Fällen mit gewaltsamem Tod zeigten über 35% der Kinder Phobien, die mit der Todesart zusammenhingen. Wie er berühmt formulierte: "Ich denke, ein rationaler Mensch kann, wenn er will, auf Basis der Beweise an Reinkarnation glauben." Sein Nachfolger Jim Tucker setzt diese Arbeit am University of Virginia's Division of Perceptual Studies fort, wo die Forschung bis heute weitergeführt wird.`,

      sourceLabel: "Quelle",
      sourceUrl: "https://med.virginia.edu/perceptual-studies/wp-content/uploads/sites/360/2015/11/REI35.pdf",
    },
// —————————————————————————————————————————————————————————
// Author: Jim Tucker //
// —————————————————————————————————————————————————————————
    {
      id: "jim-tucker",
      name: "Jim B. Tucker M.D.",
      role: "Bonner-Lowry Professor of Psychiatry and Neurobehavioral Sciences (Emeritus), UVA",
      lifeDates: "–heute",
      portrait: "https://media.thelightcall.com/authors/Jim_Tucker.jpg",
      portraitFocus: "center",
      portraitFocal: { x: 100, y: 20 },
      quote: "So schwer es zu glauben sein mag – es gibt Hinweise darauf, dass ein Leben nach dem Tod tatsächlich Realität sein könnte.",
      featuredQuote: "So schwer es zu glauben sein mag – es gibt Hinweise darauf, dass ein Leben nach dem Tod tatsächlich Realität sein könnte.",
      shortVersion: "Bahnbrechende quantitative Studie zu amerikanischen Kindern mit Reinkarnationserinnerungen. Der Fall James Leininger — Erinnerungen eines Zweijährigen an einen WWII-Piloten mit historisch verifizierten Details — gilt als einer der am besten dokumentierten weltweit.",
      longVersion: `Jim B. Tucker ist Stevensons direkter Nachfolger an der University of Virginia's Division of Perceptual Studies (DOPS). Seine bahnbrechende Arbeit konzentriert sich auf amerikanische Fälle von Kindern mit Reinkarnationserinnerungen und beweist, dass diese Phänomene weltweit auftreten, unabhängig von kulturellen Überzeugungen oder elterlichen Erwartungen. Seine Studie von 799 Fällen war die erste quantitative wissenschaftliche Analyse in den USA und legte den Grundstein für die systematische Erforschung dieses Phänomens.

Tucker entwickelte die Strength of Case Scale (SOCS), ein revolutionäres quantitatives Instrument zur Messung der Beweiskraft. Die SOCS bewertet vier wissenschaftliche Kriterien: Geburtsmale, Aussagegenauigkeit, relevante Verhaltensweisen und emotionale Verbindung. Dank dieser standardisierten Methode konnten in der DOPS-Datenbank konsistente Muster identifiziert werden: Etwa 70% der Verstorbenen starben unnatürliche Todesfälle, das durchschnittliche Intervall zwischen Tod und Wiedergeburt liegt bei etwa 16 Monaten, und rund 30% der Fälle beinhalten Geburtsmale oder -fehler, die genau Wunden aus dem vorherigen Leben entsprechen.

Einer seiner berühmtesten Fälle ist James Leininger: Ein Zweijähriger aus Louisiana, der detaillierte Erinnerungen an das Leben eines WWII-Piloten beschrieb. Das Kind konnte nicht nur den Namen (James Huston), Staffel (VF-38) und Flugzeugtyp (F4U Corsair) nennen, sondern auch präzise Todesumstände (abgeschossen vor Iwo Jima) und Namen von Kameraden. Seine Eltern verifizierten später alle Details historisch exakt. Tuckers Haltung spiegelt wissenschaftliche Sorgfalt: "Wenn es ihre Einbildung ist, dann ist das in den detaillierten Fällen verdammt noch mal ein großer Zufall." Seine Arbeit zeigt, dass diese Fälle ernsthafte wissenschaftliche Aufmerksamkeit verdienen — allerdings untersucht er ausschließlich spontane Erinnerungen bei Kindern, nicht hypnotische Regressionstherapie.`,

      sourceLabel: "Quelle",
      sourceUrl: "https://med.virginia.edu/perceptual-studies/our-research/children-who-report-memories-of-previous-lives/",
  },
// —————————————————————————————————————————————————————————
// Author: Brian Weiss //
// —————————————————————————————————————————————————————————
    {
      id: "brian-weiss",
      featured: true,
      showInQuotes: false,
      name: "Brian L. Weiss M.D.",
      role: "Ehem. Chefarzt Psychiatrie, Mount Sinai",
      lifeDates: "*1944–heute",
      portrait: "https://media.thelightcall.com/authors/brian-weiss_350.jpg",
      portraitAccordion: "https://media.thelightcall.com/authors//brian_2.jpg",
      portraitFocus: "top",
      portraitFocal: { x: 70, y: 20 },
      portraitFocalAccordion: { x: 50, y: 80 },
      quote: "Wenn Sie sich durch die Erinnerung an ein früheres Leben besser fühlen, müssen Sie die logische Gültigkeit der Erfahrung nicht in Frage stellen.",
      featuredQuote: "Das wahre Du, das unsterbliche Du, ist jenes, das von Körper zu Körper, von Leben zu Leben weiterbesteht.",
      shortVersion: "'Many Lives, Many Masters' (1988) — internationaler Bestseller mit über 1 Million verkauften Exemplaren. Skeptische Haltung veränderte sich durch eine Patientin, die unter Hypnose frühere Leben beschrieb.",
      longVersion: `Brian Weiss war ein hochangesehener Psychiater und Chefarzt am Mount Sinai Medical Center in Miami, als ein Fall im Jahr 1980 seine Arbeit grundlegend verändern sollte. Catherine, eine Patientin mit schweren Ängsten und Phobien, sprach unter Hypnose von detaillierten Erinnerungen an vergangene Leben — Informationen, die sich historisch verifizieren ließen und zu einer raschen Linderung der Symptome führten. Weiss, Absolvent der Columbia University (B.A.) und der Yale University School of Medicine (M.D.), war in konventioneller Psychiatrie ausgebildet worden. Seine psychiatrische Ausbildung hatte ihn gelehrt, dass sich alles im gegenwärtigen Leben erklären lässt.

Was als einzelner therapeutischer Fall begann, führte zu jahrzehntelanger klinischer Arbeit mit tausenden Patienten. Weiss dokumentierte systematisch regressionstherapeutische Sitzungen und ihre langfristigen Heilungseffekte. Sein Buch "Many Lives, Many Masters" (1988) wurde ein internationaler Bestseller mit über 1 Million verkaufter Exemplaren und machte Regressionstherapie einem breiten Publikum zugänglich. Es folgten "Through Time Into Healing" (1992) mit klinischen Fallstudien und Selbstregressionstechniken, "Same Soul, Many Bodies" (2004) über zukünftige Lebensprogression und "Miracles Happen" (2012).

Weiss betont, dass er anfangs skeptisch war — er hat gesagt: "Wenn ich 'agnostisch' sage, war das so: Ich wusste nicht einmal, ob ich an Gott glaube." Doch die konsistenten Ergebnisse mit verschiedenen Patienten ließen sich nicht ignorieren. Zu seinen wichtigsten Einsichten gehören: "Wir sind spirituelle Wesen, keine menschlichen Wesen. Verständnis löst Angst auf" und "Viele Phobien und Leiden haben ihre Wurzeln in Erfahrungen aus früheren Leben, deren Anerkennung durch den Patienten eine heilende Wirkung haben kann." Seine Arbeit hat tausenden Therapeuten weltweit den Weg zu regressionsbasierten Methoden eröffnet. Wichtiger Hinweis: Weiss hat keine peer-reviewten wissenschaftlichen Artikel veröffentlicht; seine Evidenz wird durch populäre Bücher, Workshops und Medienauftritte präsentiert.`,

      sourceLabel: "Quelle",
      sourceUrl: "https://www.brianweiss.com/about-the-books/many-lives-many-masters/",
    },
  ],
};

// ═══════════════════════════════════════════════════════════
// ReferencesSection — REFERENCES (Journals, Books, Audiobooks, etc.)
// ═══════════════════════════════════════════════════════════
export const references = {
  bigLabel: "WEITERFÜHRENDE REFERENZEN",
  showMore: "Mehr Referenzen",
  showLess: "Weniger",
  headline: "Vertiefung & Quellen",
  scrollCtaText: "Bereit deine eigenen Erfahrungen zu machen?",
  scrollCtaAriaLabel: "Weiter zum CTA",
  items: [
    {
      type: "journal",
      name: "International Journal of Regression Therapy",
      dates: "1986–heute",
      url: "https://regressionjournal.org",
      role: "regressionjournal.org",
      portrait: "https://media.thelightcall.com/images/paste-1772670904056.png",
      description: `Das International Journal of Regression Therapy ist das jährlich erscheinende peer-reviewed Journal, veröffentlicht seit 1986. All diese Jahre hat das Journal Artikel über die empirischen Effekte und theoretischen Implikationen der Regressionstherapie veröffentlicht.

Seit 2021 hat die Redaktion beschlossen, den Zugang zu allen Artikeln zu gewähren, die in den letzten 35 Jahren des Journals veröffentlicht wurden. So haben in dieser neuen Ära, in der das Journal unter die Fittiche der Earth Association for Regression Therapy – kurz EARTh – gekommen ist, interessierte Forscher und Therapeuten aus allen unterschiedlichen Ansätzen Zugang zu diesem Reichtum an Informationen, der von den erfahrenen Pionieren des Fachgebiets geteilt wird.`,
      sourceLabel: "Quelle",
      sourceUrl: "https://regressionjournal.org",
    },
    {
      type: "book",
      name: "Many Lives, Many Masters",
      dates: "1988",
      authors: "Brian L. Weiss M.D.",
      url: "https://brianweiss.com/books/many-lives-many-masters",
      role: "BRIAN L. WEISS M.D.",
      portrait: "https://media.thelightcall.com/authors//manylivesmanymasters.jpeg",
      description: `Der internationale Bestseller, der Regressionstherapie der Welt öffnete. Brian Weiss dokumentiert seine transformative Arbeit mit Catherine, einer Patientin die unter Hypnose plötzlich von Details aus vergangenen Leben berichtete – Informationen, die sich historisch verifizieren ließen.

Was als therapeutische Intervention begann, führte zu einer jahrzehntelangen klinischen Arbeit mit tausenden Patienten. Many Lives, Many Masters wurde zu einem der einflussreichsten Bücher der spirituellen Psychologie und machte Regressionstherapie einem breiten Publikum zugänglich.`,
      sourceLabel: "Zum Buch",
      sourceUrl: "https://brianweiss.com/books/many-lives-many-masters",
    },
    {
      type: "book",
      name: "Other Lives, Other Selves",
      dates: "1987",
      authors: "Roger J. Woolger Ph.D.",
      url: "https://www.amazon.com/Other-Lives-Selves-Psychotherapist-Discovers/dp/0553345958",
      role: "Roger J. Woolger Ph.D.",
      portrait: "https://media.thelightcall.com/authors//otherlivesotherselfes.jpg",
      description: `Eines der einflussreichsten Werke der Regressionstherapie. Roger Woolger präsentiert eine Synthese aus Jung'scher Tiefenpsychologie, Bodywork, Psychodrama, Yoga-Psychologie und schamanischen Perspektiven.

Das Buch zeigt, wie Regressionstherapie als Werkzeug dienen kann, um aktuelle Lebensprobleme durch das Verständnis früherer Leben zu lösen. Woolger integriert westliche Psychologie mit östlichen spirituellen Traditionen und schafft so einen umfassenden Ansatz für Seelenarbeit.`,
      sourceLabel: "Zum Buch",
      sourceUrl: "https://www.amazon.com/Other-Lives-Selves-Psychotherapist-Discovers/dp/0553345958",
    },
    {
      type: "book",
      name: "Life Before Life",
      dates: "2005",
      authors: "Jim B. Tucker M.D.",
      url: "https://www.amazon.com/Life-Before-Childrens-Memories-Previous/dp/031237674X",
      role: "Jim B. Tucker M.D.",
      portrait: "https://media.thelightcall.com/authors//lifebeforelife.jpg",
      description: `Jim Tucker präsentiert eine gründliche Untersuchung der Forschung zu Berichten von Kindern über Erinnerungen an frühere Leben. Diese Studie beschreibt eine Sammlung von 2.500 Fällen an der University of Virginia, die vom Beginn der Arbeit von Dr. Ian Stevenson vor mehr als vierzig Jahren an sorgfältig untersucht wurden.

Die Kinder beginnen meist im Alter von zwei oder drei Jahren, über ein früheres Leben zu sprechen, und können von einer früheren Familie oder dem Tod in einem früheren Leben berichten. Ihre Aussagen haben sich oft als für eine bestimmte verstorbenen Person genau erwiesen, und einige Kinder haben Mitglieder der früheren Familie erkannt. Eine Anzahl von ihnen hatte auch Geburtsmale oder Defekte, die mit Wunden auf dem Körper der verstorbenen Person übereinstimmten.

Life Before Life stellt die Fälle auf unkomplizierte Weise vor und erforscht die Möglichkeit, dass das Bewusstsein nach dem Tod des Gehirns fortfahren könnte. Es ist ein provokatives und faszinierendes Buch, das das Verständnis der Leser über Leben und Tod herausfordern und letztlich verändern kann.`,
      sourceLabel: "Zum Buch",
      sourceUrl: "https://www.amazon.com/Life-Before-Childrens-Memories-Previous/dp/031237674X/ref=sr_1_2?crid=1ZD24S35MAXG5&dib=eyJ2IjoiMSJ9.JT7FiJTVfWmTqVGUD0Np5YYLmkWWFmtNWPGjFvATCQpgUzPKgt18cDIrQf6yDLLjY7jUz64XfzKwyCIRgCxQ0JCzCy7gVxVQKPEoZL3zjno0m_ARh4VFRxJjN2SuvACb5iP1mHCpVCoIB4w6ibQvENsofsEbcevb1ZJ50LZEVnBIKQGehy4gEONsJJZfmHCufdgVTRBKjnOsCq5xIaRJnWiL90tKe3XthfNgeqJfzUE.9tzXkfmbVtx-y2GAnUw2Ru1irBtcDgTO2uMvptt7C2U&dib_tag=se&keywords=life%27s+before+life+tucker&qid=1774617870&s=books&sprefix=life%27s+before+life+tuc%2Cstripbooks-intl-ship%2C389&sr=1-2",
    },
  ],
};

// ═══════════════════════════════════════════════════════════
// SimpleCtaSection — SIMPLE CTA
// ═══════════════════════════════════════════════════════════
export const simpleCta = {
  label: "DEIN NEXT STEP",
  headline: "Bereit, deiner Seele zuzuhören?",
  subline: "Ein unverbindliches Erstgespräch. Wir schauen gemeinsam, ob eine Session der richtige Schritt für dich ist.",
  cta: "Freien Intro Call buchen",
};

// ═══════════════════════════════════════════════════════════
// CtaImageSection — CTA WITH IMAGE
// ═══════════════════════════════════════════════════════════
export const ctaImage = {
  label: "DEIN NÄCHSTER SCHRITT",
  headline: "Bereit, deiner Seele zuzuhören?",
  subline: "Ein unverbindliches Erstgespräch. Wir schauen gemeinsam, ob eine Session der richtige Schritt für dich ist. Kein Druck, keine Erwartung — nur ein klärendes Gespräch.",
  cta: "Freien Intro Call buchen",
  imageUrl: "https://media.thelightcall.com/images/2%20s%20350px.png",
  imageAlt: "Benjamin Kurtz",
};

// ═══════════════════════════════════════════════════════════
// TestimonialsSection — TESTIMONIALS
// Note: Individual testimonials are now in testimonials.list.js
// ═══════════════════════════════════════════════════════════
export const testimonials = {
  clientLabel: "WALL OF LOVE",
  clientSubtitle: "Erfahrungen, die bleiben",
  // Note: clients array is now managed in testimonials.list.js for dynamic editing
  clients: [
    {
      quote: "Durch Benjamins Ruhe und Klarheit konnte ich mich trotz anfänglicher Aufregung schnell auf die Session einlassen. Es ist, als würde er durch dich durchsehen und dich sofort an die Orte führen, die dir vorher nie bekannt waren – aber genau die sind, die du brauchst. Es war unbeschreiblich, an einem Ort purer Liebe jenseits von Materie zu sein, meine Engel zu treffen und an diesem Ort des absoluten Friedens zu verweilen, zu dem ich jetzt auch im Alltag immer wieder zurückkehren kann. Die Integration danach war sehr wertvoll, um die Erkenntnisse wirklich in mir zu verankern.",
      name: "Anna K.",
      context: "Health Coach, Deutschland",
      image: "https://media.thelightcall.com/client-portraits/Anna-krickel.jpg",
    },
    {
      quote: "Alles, was Benjamin mit uns gemacht hat, ging mit Leichtigkeit. Ich bin sehr schnell in den Kontakt mit mir selbst und den anderen gekommen. Benjamin hat ganz klar den Raum für Offenheit, Lernen und Freude geschaffen.",
      name: "Alexander W.",
      context: "Musikproduzent, USA",
      image: "https://media.thelightcall.com/client-portraits/alex%20w%202.jpg",
    },
    {
      quote: "Ich habe gelacht, ich habe geweint, ich war wieder in meiner Kindheit, ich war überall. Durch Benjamins Coaching-Begleitung konnte ich tief in meine Emotionen eintauchen.",
      name: "Arthur K.",
      context: "Fotograf, Deutschland",
      image: "https://media.thelightcall.com/client-portraits/arthur.jpg",
    },
    {
      quote: "Ich wollte dir sagen, dass ich mich sehr glücklich fühle – dank der Lehren und Werkzeuge, die ich während des Retreats bekommen habe. Sie helfen mir enorm, in meiner Mitte zu bleiben und alles harmonisch fließen zu lassen.",
      name: "Hernan D.",
      context: "Lifeguard, Argentinien",
      image: "https://media.thelightcall.com/client-portraits/hernan.jpg",
    },
  ],
};

// ═══════════════════════════════════════════════════════════
// BookingSection — BOOKING
// ═══════════════════════════════════════════════════════════
export const booking = {
  label: "BEREIT FÜR EIN GESPRÄCH?",
  headline: "Freien Intro Call buchen.",
  subline:
    "Kostenlos und unverbindlich. 30 Minuten. Wir schauen gemeinsam, was dich bewegt — und ob eine Session der nächste sinnvolle Schritt ist.",
  formPlaceholder: "[ Fluent Forms Embed ]",
  directBookingText: "Du willst direkt einen Termin wählen?",
  directBookingCta: "Freien Intro Call buchen",
  directBookingUrl: "https://www.benjaminkurtz.de/bookings/wakeup",
  calendarUrl: "https://www.benjaminkurtz.de/booking/benkurtz_duw17n0e/wakeup?embedded=1",
  formTopics: [
    "Seelen Rückführung",
    "Trauma / emotionale Blockaden",
    "Wiederholende Muster in Beziehungen verstehen",
    "Channeling lernen",
    "Lebensaufgabe / Purpose",
    "Spirituelles Erwachen",
  ],
};

// ═══════════════════════════════════════════════════════════
// FAQSection — FREQUENTLY ASKED QUESTIONS
// ═══════════════════════════════════════════════════════════
export const faq = {
  bigLabel: "FRAGEN & ANTWORTEN",
  headline: "Häufige Fragen zur Regression",
  items: [
    {
      question: "Was ist der Unterschied zwischen Regression Session und Past Life Regression?",
      answer: `Begriffe werden oft synonym verwendet. Regression ist der Oberbegriff: zurückgehen zu früheren Erfahrungen. Past Life Regression, Seelenrückführung oder Reinkarnationstherapie geht spezifisch in Erinnerungen an frühere Leben.
In der Praxis: Eine Session kann sich auch auf frühe Kindheit oder das aktuelle Leben konzentrieren — aber bei den meisten Klienten führt der Weg natürlicher in Seelenleben, weil dort die Ursachen für aktuelle Muster oft liegen.
Wichtig: Du musst an nichts glauben. Die Erfahrung spricht für sich.`,
    },
    {
      question: "Muss ich an Reinkarnation glauben?",
      answer: `Nein. Tatsächlich kommen viele Klienten ohne feste spirituelle Überzeugungen — oft aus Skepsis oder Neugier.

Die Forschung (University of Virginia, Ian Stevenson, Jim Tucker) zeigt: Kinder weltweit berichten spontan von früheren Leben, unabhängig von kultureller Prägung oder elterlichem Glauben. Die Erlebnisse in Sessions sprechen für sich — Glaube ist nicht Voraussetzung.

Was zählt: Deine Bereitschaft, zuzuhören — was auch immer sich zeigt.`,
    },
    {
      question: "Ist das Channeling?",
      answer: `Nein. Regression und Channeling sind unterschiedliche Praktiken.

Regression: Du bleibst immer du selbst. Alle Erfahrungen sind deine eigenen — als Kind, als Erwachsener, oder in einem anderen Seelenleben. Du hast die Kontrolle, du entscheidest, was du teilst.

Channeling: Eine andere Entität oder Energiequelle tritt in den Vordergrund. Das "Ich" tritt zurück, Informationen kommen von "außen".

In Regression Sessions können Menschen manchmal Begegnungen erleben — aber der Fokus bleibt immer auf deiner Erfahrung, deinem Weg, deiner Heilung.`,
    },
    {
      question: "Was passiert eigentlich in einer Session?",
      answer: `Du bist immer wach, bei Bewusstsein, hast die volle Kontrolle. Ich führe dich in einen tiefen Entspannungszustand — ähnlich wie Meditation, nur geführt.

Darin kannst du Zugriff auf Bilder, Emotionen, Körperwahrnehmungen bekommen — manchmal wie ein Film, manchmal wie Erinnern, manchmal wie Spüren. Was immer kommt, ist richtig.

Die meisten Klienten beschreiben es als: "Ich weiß nicht, ob das echt ist — aber es fühlt sich wahr an." Und das reicht. Veränderungen zeigen sich im Alltag danach.`,
    },
    {
      question: "Gibt es wissenschaftliche Belege?",
      answer: `Die Forschung steht am Anfang — aber es gibt mehr als viele denken:

• **University of Virginia (DOPS)**: Ca. 3.000 dokumentierte Kinderfälle mit verifizierbaren Erinnerungen an frühere Leben. Ca. 300 peer-reviewed Publikationen.
• **Journal of Regression Therapy**: Seit 1986, alle Artikel frei zugänglich, dokumentiert therapeutische Ergebnisse.
• **Neuroimaging-Studien**: Zeigen, dass Zustände wie Meditation oder Regression keine "pathologischen" Zustände sind — sondern non-ordinäre, aber voll funktionale Bewusstseinszustände.

Ehrlich: Keine randomized controlled trials nach Mainstream-Standards. Aber tausende dokumentierte Fälle, und die wichtigste Studie bist immer du — deine Erfahrung.`,
    },
    {
      question: "Für wen ist das geeignet?",
      answer: `Menschen kommen mit unterschiedlichsten Themen:

• **Ängste & Panikattacken** — Wenn die Reaktion größer ist als die Situation
• **Beziehungsmuster** — Warum sich dieselben Dynamiken wiederholen
• **Körperliche Symptome** — Ohne klare medizinische Ursache
• **Todesangst** — Den Tod als Übergang verstehen
• **Lebensaufgabe** — Warum bin ich hier?
• **Neugier** — Einfach erfahren, was da ist

Ausschluss: Akute Psychosen, schwere Depressionen ohne therapeutische Begleitung. Bei Unsicherheit: Im freien Intro Call klären.`,
    },
    {
      question: "Kann ich eine Session auch auf Deutsch machen?",
      answer: `Ja. Deutsch ist meine Muttersprache — die Session findet auf Deutsch statt, es sei denn, du wünschst ausdrücklich Englisch.

Viele Klienten finden es leichter, in ihrer Muttersprache in tiefere Zustände zu gehen. Die Bilder, Worte und Gefühle kommen dann natürlicher.`,
    },
    {
      question: "Wie lange hält die Wirkung?",
      answer: `Das ist individuell verschieden. Einige Klienten berichten von sofortiger, spürbarer Veränderung — Muster lösen sich, Symptome werden leichter. Andere beschreiben es wie einen Samen, der über Wochen und Monate wächst.

Die Integration nach der Session ist wichtig. Viele erleben auch Wochen später noch neue Einsichten oder verstehen Zusammenhänge, die sich vorher nicht erschlossen haben.

Eine Session ist kein einmaliger "Fix" — aber oft ein entscheidender Schlüsselmoment.`,
    },
    {
      question: "Was, wenn ich nichts sehe?",
      answer: `Das ist eine häufige Sorge — aber selten passiert. Jeder Mensch hat Zugang zu inneren Bildern, Empfindungen, Wahrnehmungen. Manchmal kommt es visuell (wie ein Film), manchmal als Gefühl, manchmal als Wissen, manchmal als Körpersensation.

Alles, was kommt, ist richtig. Es gibt kein "richtig" oder "falsch" in einer Session. Manchmal ist das, was NICHT kommt, auch eine Information — oder es kommt erst in einem zweiten Moment.

Mein Job ist es, dich da hinzuführen, wo du Zugang hast — und das ist bei jedem anders.`,
    },
    {
      question: "Kann ich auch nur ausprobieren, ob das was für mich ist?",
      answer: `Ja. Der freie Intro Call ist genau dafür da — kostenlos, unverbindlich, 30 Minuten. Wir schauen gemeinsam, was dich bewegt, ob eine Session passt, und du kannst fühlen, ob die Chemie stimmt.

Viele buchen danach ihre erste Session. Manche entscheiden sich, noch zu warten. Beides ist völlig okay. Es ist deine Reise, dein Timing.`,
    },
  ],
};

// ═══════════════════════════════════════════════════════════
// FOOTER
// ═══════════════════════════════════════════════════════════
export const footer = {
  brand: "Benjamin Kurtz Academy LLC",
  disclaimerLinkKeyword: "Erstgespräch",
  tagline: "Grounded Spirituality\nAligned with Your Purpose",
  contactLabel: "Kontaktiere uns:",
  legalLabel: "Rechtliches",
  followLabel: "Folgen",
  reachOutLabel: "REACH OUT",
  disclaimerTitle: "Rechtlicher Hinweis",
  disclaimer: `Regression Sessions und Hypnose sind kein Ersatz für medizinische oder psychiatrische Behandlung. Bei psychischen Erkrankungen wende dich bitte an einen approbierten Arzt oder Psychotherapeuten. Bei Unklarheiten wähle gern dennoch ein Erstgespräch, in dem ich dich dazu kompetent beraten kann.`,
  introCallLabel: "Erstgespräch",
  copyright: {
    prefix: "Alle Rechte vorbehalten. Home:",
    homeLabel: "benjaminkurtz.de",
    homeUrl: "https://benjaminkurtz.de",
  },
  contact: [
    { label: "WhatsApp",  url: "https://wa.me/4915121231244",           icon: "whatsapp"  },
    { label: "E-Mail",    url: "mailto:hello@benjaminkurtz.de",          icon: "mail"      },
    { label: "Instagram", url: "https://instagram.com/benjaminkurtz_de", icon: "instagram" },
  ],
  legalLinks: [
    { label: "Terms",   url: "https://www.benjaminkurtz.de/terms/"   },
    { label: "Privacy", url: "https://www.benjaminkurtz.de/privacy/" },
    { label: "Imprint", url: "https://www.benjaminkurtz.de/imprint/" },
  ],
  social: [
    { label: "Spotify",        url: "https://open.spotify.com/episode/3D9V2pK9kdT6ED9FENxpnW?si=7rD9pMrcSV6uLq-tOoMICA" },
    { label: "Apple", url: "https://podcasts.apple.com/pt/podcast/episode-52-reinkarnation-was-wenn-der-tod-nicht-das-ende-ist/id1680846180?i=1000751332298" },
    { label: "YouTube",        url: "https://youtu.be/U5L07PmViis?si=r1aB93QVAkpFgd97" },
  ],
};

// ═══════════════════════════════════════════════════════════
// UI LABELS (Global UI text strings)
// ═══════════════════════════════════════════════════════════
export const ui = {
  showMore: "Mehr",
  showLess: "Weniger",
  menuOpen: "Menü schließen",
  menuClosed: "Menü öffnen",
  rewind30: "30s zurück",
  forward30: "30s vor",
  pause: "Pause",
  play: "Abspielen",
  clickForMoreInfo: "Klicke für mehr Informationen",
};

// ═══════════════════════════════════════════════════════════
// TranscriptPage — TRANSCRIPT PAGE CONTENT
// ═══════════════════════════════════════════════════════════
export const transcriptPage = {
  accessDenied: {
    title: "Kein Zugang.",
    message: "Dieser Link ist nicht gültig oder abgelaufen.",
  },
  toolbar: {
    title: "Transkript",
    themeToggleDark: "Dunkel",
    themeToggleLight: "Hell",
    fontSizeDecreaseLabel: "Schrift verkleinern",
    fontSizeIncreaseLabel: "Schrift vergrößern",
    themeToggleLabel: "Hintergrund wechseln",
  },
  footer: {
    copyright: "© Benjamin Kurtz Academy · Nur für registrierte Empfänger",
  },
};

// ═══════════════════════════════════════════════════════════
// NotFoundPage — 404 PAGE CONTENT
// ═══════════════════════════════════════════════════════════
export const notFound = {
  brandName: "Benjamin Kurtz",
  title: "Seite nicht gefunden",
  message: "Die Seite, die du suchst, existiert nicht oder wurde verschoben. Lass uns zurück nach Hause gehen.",
  homeButtonLabel: "Zur Startseite",
  homeAriaLabel: "Zur Startseite",
  homeButtonAriaLabel: "Zur Startseite",
};

// ═══════════════════════════════════════════════════════════
// PodcastVideoSection — PODCAST VIDEO SECTION UI
// ═══════════════════════════════════════════════════════════
export const podcastVideo = {
  panelLabel: "Transkript",
  panelTitleLine1: "Jetzt kostenlos",
  panelTitleLine2: "herunterladen",
  closeButtonLabel: "Schließen",
  emailPrompt: "Trag deine E-Mail-Adresse ein und erhalte das vollständige Transkript der Podcast-Episode direkt in dein Postfach.",
  nameLabel: "Name",
  namePlaceholder: "Dein Vorname",
  emailLabel: "E-Mail-Adresse",
  emailPlaceholder: "deine@email.de",
  submitButtonLabel: "Transkript anfordern",
  downloadButtonLabel: "Transkript herunterladen",
  privacyNoteLine1: "Kein Spam. Du erhältst nur den Link zum Transkript.",
  privacyNoteLine2: "Du kannst dich jederzeit abmelden.",
  fluentFormsNote: "[ Fluent Forms Embed wird hier eingesetzt ]",
};

export const menu = {
  // Header-Konfiguration
  overviewLabel: "Überblick",
  header: {
    logo: {
      src: "https://media.thelightcall.com/logos/BKA%20logo%20500%20px%20black.png",
      alt: "Benjamin Kurtz Academy"
    },
    cta: {
      label: "Freier Intro Call",
      anchor: "#booking"
    },
    variant: "sidecar",
    mainNav: [
      { label: "Regression", anchor: null, hasSubmenu: true },
      { label: "Science", anchor: null, hasSubmenu: true },
      { label: "Erfahrungen", anchor: null, hasSubmenu: true },
      { label: "Über", anchor: null, hasSubmenu: true },
      { label: "FAQ", anchor: null, hasSubmenu: true },
    ],
  },
  items: [
    {
      id: "regression",
      label: "Regression",
      order: 10,
      children: [
        { id: "regression-welcome", label: "Willkommen", anchor: "#hero", order: 11 },
        { id: "regression-what", label: "Was ist Regression?", anchor: "#was-ist", order: 12 },
        { id: "regression-for-whom", label: "Wer kommt zu einer Regression?", anchor: "#fuer-wen", order: 13 },
        { id: "regression-process", label: "Ablauf einer Session", anchor: "#prozess", order: 14 },
      ],
    },
    {
      id: "science",
      label: "Science",
      order: 20,
      children: [
        { id: "science-evidence", label: "Evidenz", anchor: "#science", order: 21 },
        { id: "science-authors", label: "Forscher & Autoren", anchor: "#science", order: 22 },
        { id: "science-references", label: "Literatur", anchor: "#references", order: 23 },
      ],
    },
    {
      id: "experiences",
      label: "Erfahrungen",
      order: 30,
      children: [
        { id: "experiences-cases", label: "Fallbeispiele", anchor: "#cases", order: 31 },
        { id: "experiences-love", label: "Wall of Love", anchor: "#wall-of-love", order: 32 },
        { id: "experiences-youtube", label: "Podcast (YouTube)", anchor: "#podcast-video", order: 33 },
        { id: "experiences-audio", label: "Audio-Podcast", anchor: "#podcast", order: 34 },
      ],
    },
    {
      id: "about",
      label: "Über Benjamin Kurtz",
      anchor: "#ueber",
      order: 40,
    },
    {
      id: "faq",
      label: "FAQ",
      order: 50,
      children: [
        { id: "faq-0", label: "Regression vs. Past Life Regression?", anchor: "#faq-0", order: 51 },
        { id: "faq-1", label: "Muss ich an Reinkarnation glauben?", anchor: "#faq-1", order: 52 },
        { id: "faq-2", label: "Ist das Channeling?", anchor: "#faq-2", order: 53 },
        { id: "faq-3", label: "Was passiert in einer Session?", anchor: "#faq-3", order: 54 },
        { id: "faq-more", label: "Mehr Antworten", anchor: "#faq", order: 55 },
      ],
    },
  ],
  footer: {
    items: [
      { label: "Regression", anchor: "#was-ist" },
      { label: "Science", anchor: "#science" },
      { label: "Für wen?", anchor: "#fuer-wen" },
      { label: "Über Benjamin", anchor: "#ueber" },
      { label: "Ablauf", anchor: "#prozess" },
      { label: "Erfahrungen", anchor: "#cases" },
      { label: "FAQ", anchor: "#faq" },
      { label: "Literatur", anchor: "#references" },
    ],
  },
};

// Default export for backwards compatibility
export default {
  meta, header, hero, services, welcome, statement, quoteSection, whatIs, podcasts,
  forWhom, about, processSection, cases, researchers, references,
  simpleCta, ctaImage, testimonials, booking, faq, footer, ui,
  transcriptPage, notFound, podcastVideo, menu,
}
